export const REVIEWS_SECTION_ID = "reviews";
